import { render, staticRenderFns } from "./BoardShow.vue?vue&type=template&id=52672386&scoped=true&"
import script from "./BoardShow.vue?vue&type=script&lang=ts&"
export * from "./BoardShow.vue?vue&type=script&lang=ts&"
import style0 from "./BoardShow.vue?vue&type=style&index=0&id=52672386&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52672386",
  null
  
)

export default component.exports